export default __webpack_public_path__ + "static/media/plain-sticker-J.ae062aa4.png";